<div class="main-container user-profile-container">
  <form class="user-profile-form form-group-container" novalidate #form="ngForm" name="resetPassForm" [formGroup]="resetPassForm"
    (ngSubmit)="onSubmitSetPassword(resetPassForm.value)" [ngClass]="{submitted: isSubmitted}">

    <label class="form-control-container">
      <div class="control-label">{{'current_password' | translate}}</div>
      <div class="control-input-container">
        <input class="control-input" type="password" id="currentPassword" name="currentPassword" placeholder="{{'current_password' | translate}}" formControlName="currentPassword"
          required>
        @if (currentPassword.invalid || (currentPassword.dirty || currentPassword.touched)) {
          <div class="control-error-container error-msgs">
            @if (currentPassword.errors?.minlength) {
              <div> {{'must_8_characters_message' | translate}}</div>
            }
            @if (currentPassword.errors?.pattern) {
              <div>{{'lower_upper_case' | translate}}</div>
            }
            @if (currentPassword.errors?.maxlength) {
              <div>{{'pass_max_length' | translate}}</div>
            }
          </div>
        }
      </div>
    </label>

    @if (loader) {
      <div class="site-loader-wrapper grey-bg-loader">
        <div class="loader"></div>
      </div>
    }

    <label class="form-control-container">
      <div class="control-label">{{'new_password' | translate}}@if (isOktaLogin) {
        <span class="okta-password-note-symbol">*</span>
      }</div>
      <div class="control-input-container">
        <input class="control-input" type="password" id="newPassword" name="newPassword" placeholder="{{'new_password' | translate}}" formControlName="newPassword"
          required>
        <div class="password_suggestion_div"> <span> Suggestion: </span> <span> {{passwordSuggestValue}} </span>
        <span class="" (click)="copyPasswordToClipboard()"> <i class="fa fa-clipboard" aria-hidden="true" [title]="'copy'"></i> </span>
        <span class="refresh_icon" (click)="generateRandomPassword()"><i class="fa fa-refresh" [title]="'refresh'"></i></span>
      </div>
      @if (newPassword.invalid || (newPassword.dirty || newPassword.touched)) {
        <div class="control-error-container error-msgs">
          @if (newPassword.errors?.minlength && !checkDiverseyOrPowerAdmin()) {
            <div>{{'must_8_characters_message' | translate}}</div>
          }
          @if (newPassword.errors?.minlength && checkDiverseyOrPowerAdmin()) {
            <div> Must be at least 15 characters </div>
          }
          @if (newPassword.errors?.maxlength) {
            <div>{{'pass_max_length' | translate}}</div>
          }
          @if (newPassword.errors?.pattern) {
            <div>{{'lower_upper_case' | translate}}</div>
          }
          @if (newPassword.errors?.samePassword) {
            <div>{{'same_password' | translate}}</div>
          }
        </div>
      }
    </div>
  </label>

  <label class="form-control-container">
    <div class="control-label">{{'confirm_password' | translate}}@if (isOktaLogin) {
      <span class="okta-password-note-symbol">*</span>
    }</div>
    <div class="control-input-container">
      <input class="control-input" type="password" id="confirmPassword" name="confirmPass" placeholder="{{'confirm_password' | translate}}" formControlName="confirmPassword"
        required>
      @if (confirmPassword.invalid || (confirmPassword.dirty || confirmPassword.touched)) {
        <div class="control-error-container error-msgs">
          @if (confirmPassword.errors?.MatchPassword) {
            <div>{{'match' | translate}}</div>
          }
        </div>
      }
    </div>
  </label>
  @if (isOktaLogin) {
    <div class="okta-password-note">
      @if (isOktaLogin) {
        <span class="okta-password-note-symbol">*</span>
      }
      Modifying your password here will update your Diversey password
    </div>
  }
  <div class="form-submit-container">
    <button [ngClass]="applyClass(resetPassForm.valid)" [disabled]="!resetPassForm.valid" type="submit">{{'reset_password' | translate}}</button>
  </div>
</form>
</div>
